/**
 * Seniority Constants
 * Contains all seniority-related enums and configurations
 */

export enum SeniorityEnum {
  Trainee = 1,
  Junior = 2,
  Advanced = 3,
  Senior = 4,
  Master = 5,
}

export enum SENIORITY_STATUS {
  Done = 1,
  InProgress = 2,
  NotStarted = 3,
}

export enum SENORITIES {
  Trainee = 'Trainee',
  Junior = 'Junior',
  Advanced = 'Advanced',
  Senior = 'Senior',
  Master = 'Master',
}

export const SENIORITY_LEVELS = [
  'Trainee',
  'Junior',
  'Advanced',
  'Senior',
  'Master',
] as const;
